<template>
  <div class="content-menu" ref="imageContainer" @contextmenu.prevent="handleContextmenu">
    <slot></slot>
    <transition name="fade">
      <div v-if="isMenuVisible" class="context-menu" :style="menuPosition">
        <div @click.stop="download">
          <span class="menu-icon hitems-download"></span>
          下载
        </div>
        <div @click.stop="copyImageFn" v-if="showCopyBtn">
          <span class="menu-icon hitems-copy"></span>
          复制
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
  import { ref, onBeforeUnmount, onMounted, inject } from 'vue'
  import LongTouchPlugin from '@/utils/longTouch'
  import type { ToastServiceType } from '@/components/AppToast/toast'
  import { copyImage } from '@/utils/common'
  import httpApi from '@/http/api'

  const props = defineProps({
    imageId: {
      type: String,
      default: ''
    },
    videoId: {
      type: String,
      default: ''
    },
    topicId: {
      type: String,
      default: ''
    },
    showCopyBtn: {
      type: Boolean,
      default: true
    }
  })

  const $toast = inject<ToastServiceType>('$toast')
  const imageContainer = ref<HTMLElement | null>(null)
  const isMenuVisible = ref(false)
  const menuPosition = ref({ top: '0px', left: '0px' })

  const handleContextmenu = (event: MouseEvent) => {
    event.preventDefault()
    menuPosition.value = {
      top: `${event.clientY}px`,
      left: `${event.clientX + 10}px`
    }
    isMenuVisible.value = true
  }

  const longTouchCallback = (event: TouchEvent) => {
    event.preventDefault()
    menuPosition.value = {
      top: `${event.touches[0].clientY}px`,
      left: `${event.touches[0].clientX + 10}px`
    }
    isMenuVisible.value = true
  }
  const longTouchDuration = 500
  const longTouchPlugin = new LongTouchPlugin(longTouchDuration, longTouchCallback)

  const download = () => {
    $toast &&
      $toast({
        message: '下载中',
        type: 'success'
      })
    if (props.videoId) {
      downloadVideo()
    } else {
      downloadImage()
    }
    isMenuVisible.value = false
  }

  const downloadVideo = async () => {
    const res: any = await httpApi.downloadSingleVideo(props.videoId)
    httpApi.downloadByTag(res.data.videoUrl)
  }

  const downloadImage = () => {
    const link = document.createElement('a')
    link.href = `/aigc/api/download/image?uniqueImageId=${props.imageId}&topicId=${props.topicId || ''}`
    link.target = '_blank'
    link.download = 'download.png'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const copyImageFn = async () => {
    $toast &&
      $toast({
        message: '复制中...',
        type: 'success'
      })
    isMenuVisible.value = false
    await copyImage(
      `/aigc/api/download/image?uniqueImageId=${props.imageId}&topicId=${props.topicId || ''}`
    )
    $toast &&
      $toast({
        message: '图片已复制',
        type: 'success'
      })
  }

  const hideMenu = () => {
    if (imageContainer.value) {
      isMenuVisible.value = false
    }
  }

  onMounted(() => {
    document.addEventListener('click', hideMenu)
    imageContainer.value && longTouchPlugin.init(imageContainer.value)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', hideMenu)
  })
</script>

<style scoped>
  .context-menu {
    position: fixed;
    width: 16.4rem;
    overflow: hidden;
    z-index: 102;
    background-color: #333;
    border-radius: 1rem;
    color: #fff;
    font-size: 1.6rem;
  }

  .context-menu div {
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: start;
    cursor: pointer;
    font-style: normal;
    padding-left: 2rem;
  }

  .menu-icon {
    font-size: 1.8rem;
    margin-right: 1rem;
  }

  .context-menu div:hover {
    background-color: #101010;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
